import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { jsonLocalDateReplacer, removePropertiesWithNullValues } from '@shared/shared-functions';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
@Component({
    selector: 'app-json-modal',
    templateUrl: './json-modal.component.html',
    styleUrls: ['./json-modal.component.scss'],
})
export class JsonModalComponent implements OnInit {
    serializedObject: string;
    object: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { title: string; object: any },
        public dialogRef: MatDialogRef<ErrorModalComponent>,
    ) {
        this.object = JSON.stringify(removePropertiesWithNullValues(data.object), jsonLocalDateReplacer, 5);
    }

    ngOnInit() {}
}
